import * as React from "react";
const SvgCheckCircle = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      clipPath="url(#check-circle_svg__a)"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 5.54V6a5 5 0 1 1-2.965-4.57" />
      <path d="M11 2 6 7.005l-1.5-1.5" />
    </g>
    <defs>
      <clipPath id="check-circle_svg__a">
        <path fill="currentColor" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCheckCircle;
